import { SessionApi, Configuration } from '@/rest'
import { AppModule } from '../store/modules/app';

export default function removeAssetFromSession(assetId : number): Promise<void> {
    return new Promise<void>((resolve, reject) => {
        let sessionApi = new SessionApi(
            new Configuration({ basePath: '/rest'})
        )

        let assetIds : number[] = []
        assetIds.push(assetId)

        let sessionId = ""
        if(AppModule.session && AppModule.session.sessionId) {
            sessionId = AppModule.session.sessionId
        }
        
        let request = {"addSessionAssetsRequest" : {"sessionId" : sessionId, 'assets' : assetIds}}
        sessionApi.sessionRemoveAssetsPost(request).then(
            (responseValue) => {
                resolve()
            },
            (reason) => {
                window.console.log(reason)
                reject()
            });

        resolve()
    });
}